import { formatDateHuman, parseDateRaw } from "../date-utils";
export const ingredientStockDtoFields = [{
        name: "clfIngredientType",
        title: "Ingrediente",
        render: (record) => record.clfIngredientType.description
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.ingredientStock.lotNumber
    }, {
        name: "quantity",
        title: "Quantità",
        render: (record) => record.ingredientStock.quantity
    }, {
        name: "roomType",
        title: "Stoccaggio",
        render: (record) => record.roomTypeName
    }, {
        name: "supplierName",
        title: "Fornitore",
        render: (record) => record.supplierName
    }, {
        name: "validFromDate",
        title: "Inizio Validità",
        render: (record) => formatDateHuman(parseDateRaw(record.ingredientStock.validFromDate))
    }, {
        name: "validUptoDate",
        title: "Fine Validità",
        render: (record) => !!record.ingredientStock.validUptoDate ? formatDateHuman(parseDateRaw(record.ingredientStock.validUptoDate)) : ""
    }];
